// Automatically loads research interests for the current user, set
// by the `users/user_research_interests` partial. That partial must
// be rendered on the current page, or this will throw an error.

import { getAutoProps } from 'js/auto_props/client';

type ResearchInterest = {
  id: number;
};

let userResearchInterests: ResearchInterest[] | undefined = undefined;

const getUserResearchInterests = (): ResearchInterest[] => {
  if (typeof userResearchInterests !== 'undefined') {
    return userResearchInterests;
  }

  userResearchInterests = getAutoProps('UserResearchInterests').interests;

  return userResearchInterests;
};

const setUserResearchInterests = (
  setter: (interests: ResearchInterest[]) => ResearchInterest[],
) => {
  userResearchInterests = setter(getUserResearchInterests());
};

export const hasInterest = (interestId: number): boolean => {
  const interests = getUserResearchInterests();
  return interests.some((i) => i.id === interestId);
};

export const addInterest = (interestId: number): void => {
  setUserResearchInterests((interests) => [...interests, { id: interestId }]);
};

export const removeInterest = (interestId: number): void => {
  setUserResearchInterests((interests) =>
    interests.filter((i) => i.id !== interestId),
  );
};
